<!--
    The field is min-w-0 so it can shrink below its intrinsic width, the actions are shrink-0 so a
    long translated label is never clipped. No fixed widths - the row stacks below the sm breakpoint.
    items-start (rather than stretch or center) keeps the action group from growing with the field's
    subscript; it sizes itself to the input box instead - see the .actions rule in the stylesheet.
-->
<div class="flex flex-col gap-2 sm:flex-row sm:items-start sm:gap-4">
    <mat-form-field class="w-full min-w-0 grow" subscriptSizing="dynamic">
        <mat-label>{{ label() }}</mat-label>
        <mat-select
            [ngModel]="value()"
            (ngModelChange)="onSelectionChange($event)"
            [multiple]="true"
            [required]="required()">
            @if (selectedNames().length > 0) {
                <mat-select-trigger>
                    {{ selectedNames()[0] }}
                    @if (selectedNames().length > 1) {
                        <span class="opacity-60"
                            >(+{{ selectedNames().length - 1 }})</span
                        >
                    }
                </mat-select-trigger>
            }
            @for (option of options(); track option.value) {
                <!--
                    A locked option renders checked but disabled, which is the standard Material
                    affordance for "mandatory". Blocking the click here is what keeps the invariant
                    honest instead of quietly re-adding the value when the dialog is saved.
                -->
                <mat-option
                    [value]="option.value"
                    [disabled]="lockedSet().has(option.value)">
                    {{ option.name }}
                </mat-option>
            }
        </mat-select>
        @if (hint()) {
            <mat-hint>{{ hint() }}</mat-hint>
        }
        @if (required()) {
            <mat-error>{{
                'shared.validation.required' | translate
            }}</mat-error>
        }
    </mat-form-field>
    <div class="actions flex shrink-0 items-center gap-2">
        <button
            mat-stroked-button
            type="button"
            class="grow whitespace-nowrap sm:grow-0"
            (click)="toggleAll()">
            <!--
                Both labels share one grid cell, so the button always reserves the width of the
                longer of the two in the active locale. Its width never changes when the state
                flips, which keeps the select next to it at a constant width. The hidden label
                uses visibility (not display) so it still reserves space but stays out of the
                accessibility tree.
            -->
            <span class="grid">
                <span
                    class="col-start-1 row-start-1"
                    [class.invisible]="allSelected()">
                    {{ 'shared.multiSelect.selectAll' | translate }}
                </span>
                <span
                    class="col-start-1 row-start-1"
                    [class.invisible]="!allSelected()">
                    {{ 'shared.multiSelect.deselectAll' | translate }}
                </span>
            </span>
        </button>
        <button
            mat-icon-button
            type="button"
            [disabled]="!canUndo()"
            [attr.aria-label]="'shared.multiSelect.undo' | translate"
            matTooltip="{{ 'shared.multiSelect.undo' | translate }}"
            (click)="undo()">
            <mat-icon>undo</mat-icon>
        </button>
    </div>
</div>
